import { isIterable } from "@thi.ng/checks";
import { iterator } from "../iterator";
import { partitionBy } from "./partition-by";
export function partitionOf(sizes, src) {
    return isIterable(src)
        ? iterator(partitionOf(sizes), src)
        : partitionBy(() => {
            let i = 0, j = 0;
            return () => {
                if (i++ === sizes[j]) {
                    i = 1;
                    j = (j + 1) % sizes.length;
                }
                return j;
            };
        }, true);
}
